import { Link } from 'react-router';

import { MARKETING_APP_ENTRY_HREF, marketingFooterLegalLinks, marketingFooterSections } from '../marketingContent';
import { PrimaryCTA } from './PrimaryCTA';

import styles from './SiteFooter.module.css';

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer} data-background="navy">
      <div className={styles.inner}>
        <section className={styles.topCta}>
          <div className={styles.topCopy}>
            <p className={styles.topEyebrow}>New to Kudu?</p>
            <h2 className={styles.topTitle}>
              Start a free course in 2 minutes.
            </h2>
          </div>
          <PrimaryCTA href={MARKETING_APP_ENTRY_HREF} label="Start a free course in 2 minutes" />
        </section>

        <div className={styles.columns}>
          <section className={styles.brandColumn}>
            <Link className={styles.brand} to="/">
              Kudu
            </Link>
            <p className={styles.tagline}>Education&apos;s technology layer.</p>
            <p className={styles.brandCopy}>
              One place for course materials, assignments, and AI support
              without adding another patchwork system.
            </p>
            <Link className={styles.inlineLink} to="/contact">
              Contact the team
            </Link>
          </section>

          {marketingFooterSections.map((section) => (
            <section className={styles.column} key={section.title}>
              <h3 className={styles.columnTitle}>{section.title}</h3>
              <ul className={styles.linkList}>
                {section.links.map((link) => (
                  <li key={link.href}>
                    <Link className={styles.link} to={link.href}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <div className={styles.bottomBar}>
          <p className={styles.copyright}>
            © {year} Kudu. All rights reserved.
          </p>
          <div className={styles.legalLinks}>
            {marketingFooterLegalLinks.map((link) => (
              <Link className={styles.legalLink} key={link.href} to={link.href}>
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
